import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';

import Layout from '../Components/Layout';
import UpdateLogin from '../Components/MyProfile/UpdateLogin';
import UpdateIdentification from '../Components/MyProfile/UpdateIdentification';
import UpdateContact from '../Components/MyProfile/UpdateContact';
import UpdateNotification from '../Components/MyProfile/UpdateNotification';

import UserLockout from '../utils/user_lockout';

import '../Components/MyProfile/style.scss';

const MyProfilePage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    const passwordExpired = (actions) => {
        if (actions?.includes('change-password')) {
            return (
                <div className='alert alert-danger text-center my-4' role='alert'>
                    <p className='my-0'>Your password has expired. Please update it now to continue using all of the features of 2nd Chance</p>
                </div>
            );
        }
    };

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <UserLockout currentSection='my-profile'>
                <div className='my-profile-container'>
                    <div className='page-head-title'>My Profile</div>
                    <div className='my-5' />
                    {passwordExpired(user.actions)}
                    <UpdateLogin />
                    <div className='my-5' />
                    <UpdateIdentification />
                    <div className='my-5' />
                    <UpdateContact />
                    <div id='notification' className='my-5' />
                    <UpdateNotification />
                </div>
            </UserLockout>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyProfilePage);
